<script>
  import {useQuery} from "@sveltestack/svelte-query"
  import Stepper from "../../../components/stepper/Stepper.svelte";
  import ImportStep from "./ImportStep.svelte";
  import ParametersStep from "./ParametersStep.svelte";
  import PageTitle from "../../parts/PageTitle.svelte";
  import ConfirmationStep from "./ConfirmationStep.svelte";
  import ValidationStep from "./ValidationStep.svelte";
  import ExecutionStep from "./ExecutionStep.svelte";
  import { getAutoMpsProjectContext } from "../../AutoMpsProjectContext.js";
  import Loading from "../../../components/pages/Loading.svelte";
  import NonDemoExecutionStep from "./NonDemoExecutionStep.svelte";

  const ctx = getAutoMpsProjectContext()

  let currentStep = 0
  const steps = [
    {label: "データの選択"},
    {label: "平準化の設定"},
    {label: "データ・設定の確認"}
  ]

  let importsBundle = {
    demand: "latest",
    item: "latest",
    inventory: "latest",
    production: "latest",
    calendar: "latest",
    shift: "latest",
    parameter: "latest",
  }

  let plan = null
  let executionId = null

  const query = useQuery(`/api/auto-mps/projects/${$ctx.projectId}/settings/asprova`)
</script>

<div class="content-root">
  <PageTitle>新しい平準化計画を立てる</PageTitle>
  {#if $query.isLoading || !$query.data}
    <Loading />
  {:else}
    {#if !$query.data.demo}
      <NonDemoExecutionStep />
    {:else}
      <Stepper activeStep={currentStep} steps={steps}/>
      {#if currentStep === 0}
        <ImportStep
          onClickNext={() => currentStep = 1}
          bind:inputDataBundle={importsBundle}
        />
      {/if}
      {#if currentStep === 1}
        <ParametersStep
          onClickBack={() => currentStep = 0}
          onClickNext={() => currentStep = 2}
          bind:selectedParameterDataId={importsBundle.parameter}
        />
      {/if}
      {#if currentStep === 2}
        <ValidationStep
          onClickNext={() => currentStep = 3}
          onClickBack={() => currentStep = 1}
          importsBundle={importsBundle}
          bind:plan={plan}
        />
      {/if}
      {#if currentStep === 3}
        <ConfirmationStep
          onClickBack={() => currentStep = 1}
          moveNext={eid => {
            executionId = eid
            currentStep = 4
          }}
          inputDataBundle={importsBundle}
          plan={plan}
        />
      {/if}
      {#if currentStep === 4 && executionId}
        <ExecutionStep
          executionId={executionId}
        />
      {/if}
    {/if}
  {/if}
</div>

<style>
  .content-root {
    height: 100%;
    background-color: white;
    padding: 1rem;
  }
</style>